var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdminNeeded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "424px",
    height: "207px",
    viewBox: "0 0 424 207",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 408,
    height: 191,
    rx: 9.55
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-3.1%",
    y: "-6.0%",
    width: "106.1%",
    height: "113.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-9.000000, -11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(17.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(52.032767, 30.739444)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    opacity: 0.167992001
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#060D24",
    x: 4.54747351e-13,
    y: 0,
    width: 230.799757,
    height: 9.47888802,
    rx: 3.39730739
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5A607E",
    x: 0,
    y: 16.8219812,
    width: 302.967233,
    height: 9.47888802,
    rx: 3.39730739
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5A607E",
    x: 9.09494702e-13,
    y: 29.6861864,
    width: 277.776699,
    height: 9.47888802,
    rx: 3.39730739
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 45.699131)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#060D24",
    opacity: 0.167992001,
    x: 0,
    y: 34.3963508,
    width: 214.359375,
    height: 9.47888802,
    rx: 3.39730739
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#475BFF",
    x: 0,
    y: 52,
    width: 51,
    height: 14,
    rx: 2.37811518
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#475BFF",
    x: 4.54747351e-13,
    y: 70,
    width: 51,
    height: 14,
    rx: 2.37811518
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5A607E",
    opacity: 0.167992001,
    x: 56.078125,
    y: 54.218332,
    width: 175,
    height: 9.47888802,
    rx: 3.39730739
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5A607E",
    opacity: 0.167992001,
    x: 56.453125,
    y: 72.0825372,
    width: 57,
    height: 9.47888802,
    rx: 3.3973074
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#475BFF",
    x: 4.54747351e-13,
    y: 0,
    width: 51,
    height: 14,
    rx: 2.37811518
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#5A607E",
    opacity: 0.167992001,
    x: 56.453125,
    y: 2.0825372,
    width: 57,
    height: 9.47888802,
    rx: 3.3973074
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillOpacity: 0.6,
    fill: "#FFFFFF",
    x: 10,
    y: 14,
    width: 389,
    height: 165
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(164.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "badge-check-solid"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 15.8,
    y: 24.3076923,
    width: 46.1846154,
    height: 35.2461538
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.5,0 C45.178125,0 50.115625,3.19394531 52.5998047,7.88457031 C57.6761719,6.18730469 63.2771484,7.554375 67.4277344,11.5691797 C71.4394531,15.5839844 72.5349609,21.3238281 71.1154297,26.4001953 C75.8060547,28.884375 79,33.821875 79,39.5 C79,45.178125 75.8060547,50.115625 71.1154297,52.5998047 C72.6738281,57.6761719 71.4394531,63.2771484 67.4277344,67.4277344 C63.2771484,71.4394531 57.6761719,72.5349609 52.5998047,71.1154297 C50.115625,75.8060547 45.178125,79 39.5,79 C33.821875,79 28.884375,75.8060547 26.4001953,71.1154297 C21.3238281,72.6738281 15.5839844,71.4394531 11.5691797,67.4277344 C7.554375,63.2771484 6.32617188,57.6761719 7.88457031,52.5998047 C3.19394531,50.115625 0,45.178125 0,39.5 C0,33.821875 3.19394531,28.884375 7.88457031,26.4001953 C6.18730469,21.3238281 7.554375,15.5839844 11.5691797,11.5691797 C15.5839844,7.554375 21.3238281,6.32617188 26.4001953,7.88457031 C28.884375,3.19394531 33.821875,0 39.5,0 L39.5,0 Z",
    id: "Shape",
    fill: "#475BFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lock-solid",
    transform: "translate(23.000000, 21.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.89285714,14.25 L5.89285714,10.6875 C5.89285714,4.78488281 10.6439732,0 16.5,0 C22.3560268,0 27.1071429,4.78488281 27.1071429,10.6875 L27.1071429,14.25 L28.2857143,14.25 C30.8859375,14.25 33,16.3800781 33,19 L33,33.25 C33,35.8699219 30.8859375,38 28.2857143,38 L4.71428571,38 C2.11037946,38 0,35.8699219 0,33.25 L0,19 C0,16.3800781 2.11037946,14.25 4.71428571,14.25 L5.89285714,14.25 Z M10.6071429,14.25 L22.3928571,14.25 L22.3928571,10.6875 C22.3928571,7.40851562 19.7558036,4.75 16.5,4.75 C13.2441964,4.75 10.6071429,7.40851562 10.6071429,10.6875 L10.6071429,14.25 Z",
    id: "Shape"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminNeeded);
export default __webpack_public_path__ + "static/media/AdminNeeded.210362ea95261dae2dbea91c44292a08.svg";
export { ForwardRef as ReactComponent };